'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp', ['mgpCorregedoriaApp.validacao', 'mgpCorregedoriaApp.info']).run(Run);

  function Run($rootScope, amMoment) {

    amMoment.changeLocale('pt-BR');

    $rootScope.$on("$viewContentLoaded", function () {
      if ($('.left-bar').hasClass('stash')) {
        $('.right-side').addClass('stash');
        $('.content').addClass('stash');
      }
    });
  }
})();
'use strict';

angular.module('services.config', []).constant('configuration', {
  baseURL: '/mgp-corregedoria/',
  preferredLanguage: 'pt-BR'
});
'use strict';

(function () {
    'use strict';

    angular.module('mgpCorregedoriaApp').config(Config);

    function Config($translateProvider, $urlRouterProvider, $stateProvider, configuration, $qProvider, blockUIConfig) {

        $stateProvider.state('about', {
            url: "/about",
            templateUrl: "views/about.html"
        });

        $urlRouterProvider.otherwise("/");

        $translateProvider.useStaticFilesLoader({ prefix: configuration.baseURL, suffix: '.json' });
        $translateProvider.preferredLanguage(configuration.preferredLanguage);
        $translateProvider.useSanitizeValueStrategy('sceParameters');
        $qProvider.errorOnUnhandledRejections(false);

        blockUIConfig.delay = 100;
        blockUIConfig.autoBlock = false;
    }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp').config(Configuration);

  Configuration.$inject = ['$httpProvider', 'ngsalConfig'];

  function Configuration($httpProvider, ngsalConfig) {

    var nomeApp = 'mgp-corregedoria';

    ngsalConfig.applicationName = nomeApp;
    ngsalConfig.homePath = 'home';
    ngsalConfig.apiVersion = 'v1';

    $httpProvider.interceptors.push(['$q', 'toaster', function ($q, toaster) {

      return {
        'response': function response(_response) {

          var title = _response.headers('title');
          var message = _response.headers('message');

          switch (_response.status) {
            case 200:
            case 201:
            case 202:
            case 204:
              break;
            default:
              toaster.pop('success', title, message);
          }

          return _response;
        },

        'responseError': function responseError(errorResponse) {

          switch (errorResponse.status) {
            case 0:
              toaster.pop('error', 'Desculpe', 'Nossos servidores encontram-se indisponíveis no momento.');
              break;
            case 400:
              angular.forEach(errorResponse.data.violations, function (value) {
                toaster.pop('warning', nomeApp, value.message);
              });
              //                                toaster.pop('warning', nomeApp, errorResponse.data.error);
              break;
            case 403:
              // 403-Forbidden - Tem autenticacao, mas, o acesso é proibido para este usuario.
              toaster.pop('warning', nomeApp, 'Você não tem permissão para acessar este conteúdo, ou partes, do conteudo, que foi requisitado.');
              break;
            case 404:
              toaster.pop('info', nomeApp, 'Nenhum registro encontrado');
              break;
            case 409:
              angular.forEach(errorResponse.data.violations, function (value) {
                toaster.pop('warning', nomeApp, value);
              });
              break;
            case 500:
              //Neste caso o melhor é
              toaster.pop('error', nomeApp, errorResponse.data.error + ' ticket[' + errorResponse.data.ticket + ']', 9000, '');
              break;
            default:
              break;
          }

          return $q.reject(errorResponse);
        }
      };
    }]);
  }
})();
'use strict';

(function () {
    'use strict';

    angular.module('mgpCorregedoriaApp').factory('jsog', Jsog);

    function Jsog() {
        return JSOG;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('mgpCorregedoriaApp.validacao', ['mgpCorregedoriaApp.core']);
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.info', ['mgpCorregedoriaApp.core']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('GlosaService', GlosaService);

  function GlosaService($http, ngsalConfig) {

    var service = {
      getLinhasPrincipal: getLinhasPrincipal,
      getRelatorioCorrente: getRelatorioCorrente,
      getRegistros: getRegistros,
      getFeitosMes: getFeitosMes,
      getFeitosAbertosMais30Dias: getFeitosAbertosMais30Dias,
      getEnvioRegistro: getEnvioRegistro,
      recuperaJustificativaGlosaTotalByRmenDK: recuperaJustificativaGlosaTotalByRmenDK
    };

    return service;

    function getLinhasPrincipal(pessDk, relDk) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk + "/principal").then(function (response) {
        return response.data;
      });

      return promise;
    }

    function getRelatorioCorrente(pessDk, relDk) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk).then(function (response) {
        return response.data;
      });

      return promise;
    }

    function getRegistros(pessDk, relDK, paiDK) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDK + "/" + paiDK).then(function (response) {
        return response.data;
      });

      return promise;
    }

    function getFeitosMes(pessDk, relDk, paiDK) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk + "/totalizador/" + paiDK).then(function (response) {
        return response.data;
      });

      return promise;
    }

    function getFeitosAbertosMais30Dias(pessDk, relDk) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk + "/abertos30dias").then(function (response) {
        return response.data;
      });

      return promise;
    }

    function getEnvioRegistro(pessDk, relDk) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk + "/msmMca").then(function (response) {
        return response.data;
      });

      return promise;
    }

    function recuperaJustificativaGlosaTotalByRmenDK(pessDk, relDk) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk + "/glosaTotal").then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.core', ['ngAnimate', 'ngResource', 'ui.router', 'ngSanitize', 'ui.bootstrap', 'toaster', 'pascalprecht.translate', 'ng-sal', 'ui.utils', 'ui.mask', 'ui.utils.masks', 'services.config', 'ngFileSaver', 'angular-sparkline-charts', 'angucomplete-alt', 'chart.js', 'blockUI', 'angularMoment']);
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($translateProvider, $urlRouterProvider, $stateProvider) {
    $stateProvider.state('home', {
      url: "/home",
      templateUrl: "module/core/home.html"
    });
  }
})();
'use strict';

angular.module('services.config', []).constant('configuration', {
  baseURL: '/mgp-corregedoria/',
  preferredLanguage: 'pt-BR'
});
'use strict';

(function () {
    'use strict';

    angular.module('mgpCorregedoriaApp').controller('AccordionMenu', AccordionMenu);

    function AccordionMenu($scope) {
        $scope.oneAtATime = true;
        $scope.status = {
            isFirstOpen: false,
            isSecondOpen: false,
            isThirdOpen: false,
            isFourthOpen: false,
            isFifthOpen: false,
            isSixOpen: false
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('mgpCorregedoriaApp').controller('MenuController', MenuController);

    function MenuController($scope) {
        $scope.boxOpen = true;
        $scope.toggle = function () {
            $scope.boxOpen = !$scope.boxOpen;
        };
        $scope.toothlet = function () {
            $(".left-side, .right-side, .left-bar, nav.navbar.navbar-default.navbar-fixed-top, .content-header h1").toggleClass("stash");
        };
    }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('i18n', i18n);

  function i18n($filter) {

    var service = {
      translate: translate
    };

    return service;

    function translate(key) {
      return $filter('translate')(key);
    }
  }
})();
'use strict';

// FIXME TESTAR!!!

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').directive('nodeListVisualizacao', NodeListVisualizacao);

  function NodeListVisualizacao($compile, $templateCache) {

    var directive = {

      restrict: 'E',
      terminal: true,
      scope: {
        nodes: '=ngModel',
        add: '&'
      },
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element) {
      if (angular.isArray(scope.nodes)) {
        element.append($templateCache.get('sub-registros-visualizacao.html'));
      }
      $compile(element.contents())(scope.$new());
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('GlosaConteudo', GlosaConteudo);

  function GlosaConteudo($stateParams, GlosaService, $uibModal, $rootScope, $scope, $state) {

    var vm = this;

    vm.init = init;
    vm.add = add;
    vm.populate = populate;
    vm.refresh = refresh;

    vm.init();

    function init() {
      vm.promotorSelecionado = $state.params.promotorSelecionado;
      vm.relDkSelecionado = $state.params.relDkSelecionado;
      vm.paiDK = $stateParams.paiDK;
      vm.refresh();
      $scope.$on('event:changeViewMode', function () {
        vm.refresh();
      });
    }

    function refresh() {
      vm.viewMode = $rootScope.viewMode;
      vm.registrosList = [];
      vm.populate(vm.registrosList);
    }

    function add(member) {
      vm.paiDK = member.linhaDK;
      vm.populate(member.subregistros);
    }

    function populate(lista) {

      if (lista.length === 0) {

        GlosaService.getRegistros(vm.promotorSelecionado.originalObject.pessDk, vm.relDkSelecionado, vm.paiDK).then(function (data) {
          data.forEach(function (e) {
            e.subregistros = [];
            e.pessoaDk = vm.promotorSelecionado.originalObject.pessDk;
            e.relatorioSelecionadoDk = vm.relDkSelecionado;
            lista.push(e);
          });
        });
      }
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('GlosaService', GlosaService);

  function GlosaService($http, ngsalConfig) {

    var service = {
      getLinhasPrincipal: getLinhasPrincipal,
      getRelatorioCorrente: getRelatorioCorrente,
      getRegistros: getRegistros,
      getFeitosMes: getFeitosMes,
      getFeitosAbertosMais30Dias: getFeitosAbertosMais30Dias,
      getEnvioRegistro: getEnvioRegistro,
      recuperaJustificativaGlosaTotalByRmenDK: recuperaJustificativaGlosaTotalByRmenDK
    };

    return service;

    function getLinhasPrincipal(pessDk, relDk) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk + "/principal").then(function (response) {
        return response.data;
      });

      return promise;
    }

    function getRelatorioCorrente(pessDk, relDk) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk).then(function (response) {
        return response.data;
      });

      return promise;
    }

    function getRegistros(pessDk, relDK, paiDK) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDK + "/" + paiDK).then(function (response) {
        return response.data;
      });

      return promise;
    }

    function getFeitosMes(pessDk, relDk, paiDK) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk + "/totalizador/" + paiDK).then(function (response) {
        return response.data;
      });

      return promise;
    }

    function getFeitosAbertosMais30Dias(pessDk, relDk) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk + "/abertos30dias").then(function (response) {
        return response.data;
      });

      return promise;
    }

    function getEnvioRegistro(pessDk, relDk) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk + "/msmMca").then(function (response) {
        return response.data;
      });

      return promise;
    }

    function recuperaJustificativaGlosaTotalByRmenDK(pessDk, relDk) {
      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk + "/glosaTotal").then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('VisualizacaoRelatorio', VisualizacaoRelatorio);

  function VisualizacaoRelatorio($state, $rootScope, GlosaService, VisualizacaoService) {

    var vm = this;

    $rootScope.$state = $state; // necessario para exibir o nome da aba selecionada

    vm.init = init;
    vm.getRelatorioCorrente = getRelatorioCorrente;
    vm.montaAbasVisualizacao = montaAbasVisualizacao;
    vm.voltarTelaFiltro = voltarTelaFiltro;

    vm.init();

    function init() {

      // viewMode default
      $rootScope.viewMode = 'cards';

      vm.promotorSelecionado = $state.params.promotorSelecionado;
      vm.relDkSelecionado = $state.params.relDkSelecionado;

      if (vm.promotorSelecionado && vm.relDkSelecionado) {
        vm.montaAbasVisualizacao();
        vm.getRelatorioCorrente();
      }
    }

    function montaAbasVisualizacao() {
      VisualizacaoService.getAbasVisualizacao(vm.promotorSelecionado.originalObject.pessDk, vm.relDkSelecionado).then(function (data) {

        vm.tabs = data;

        // aba selecionada por default
        vm.tabSelected = vm.tabs[0];
      });
    }

    function getRelatorioCorrente() {
      GlosaService.getRelatorioCorrente(vm.promotorSelecionado.originalObject.pessDk, vm.relDkSelecionado).then(function (data) {
        vm.relatorioGlosa = data;
      });
    }

    function voltarTelaFiltro() {
      $state.go('validoEnviados', {
        periodoSelecionado: $state.params.periodoSelecionado,
        nomeOrgaoFiltrado: $state.params.nomeOrgaoFiltrado,
        promotorSelecionado: $state.params.promotorSelecionado,
        referer: 'botaoVoltar',
        somenteEnviados: true,
        situacaoSelecionada: $state.params.situacaoSelecionada
      });
    }
  }
})();
'use strict';

(function () {

    'use strict';

    angular.module('mgpCorregedoriaApp.validacao').config(Config);

    function Config($stateProvider) {
        $stateProvider.state('visualizacao', {
            abstract: true,
            url: "/membro/validacao/relatorio",
            templateUrl: "module/validacao/visualizacao/visualizacao.html",
            controller: 'VisualizacaoRelatorio',
            controllerAs: 'vm',
            params: {
                periodoSelecionado: '',
                nomeOrgaoFiltrado: '',
                promotorSelecionado: '',
                relDkSelecionado: '',
                situacaoSelecionada: ''
            }
        }).state('visualizacao.atuacao', {
            url: "/atuacao/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.extrajudicial', {
            url: "/extrajudicial/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.judicial.naocriminal', {
            url: "/judicial-naocriminal/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.extrajudicial.naocriminal', {
            url: "/extrajudicial-naocriminal/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.preprocessual', {
            url: "/preprocessual/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.processual', {
            url: "/processual/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.judicial', {
            url: "/judicial/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.criminal', {
            url: "/criminal/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.eleitoral', {
            url: "/eleitoral/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.ciencias', {
            url: "/ciencias/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.recursos', {
            url: "/recursos/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.outros', {
            url: "/outros/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.emnomedopai', {
            url: "/emnomedopai/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        }).state('visualizacao.averiguacoesoficiosas', {
            url: "/averiguacoesoficiosas/:paiDK",
            templateUrl: "module/validacao/visualizacao/glosa-conteudo-abas.html",
            controller: 'GlosaConteudo',
            controllerAs: 'vm'
        });
    }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('VisualizacaoService', VisualizacaoService);

  function VisualizacaoService($http, ngsalConfig) {

    var service = {
      getAbasVisualizacao: getAbasVisualizacao,
      getDetalhamentoAnalitico: getDetalhamentoAnalitico
    };

    return service;

    function getAbasVisualizacao(pessDk, relMensalDk) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relMensalDk + "/abas").then(function (response) {
        return response.data;
      });

      return promise;
    }

    function getDetalhamentoAnalitico(pessDk, relDk, linhaDK) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/promotor/" + pessDk + "/relatorio/" + relDk + "/analitico/" + linhaDK).then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('AbaFeitosMes', AbaFeitosMes);

  function AbaFeitosMes(GlosaService, $stateParams, $state) {

    var vm = this;

    vm.init = init;

    vm.registrosList = [];

    vm.init();

    function init() {
      vm.promotorSelecionado = $state.params.promotorSelecionado;
      GlosaService.getFeitosMes(vm.promotorSelecionado.originalObject.pessDk, $stateParams.relMensalDk, $stateParams.paiDK).then(function (data) {
        vm.registrosList = data;
      });
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider.state('visualizacao.feitosMes', {
      url: "/feitosMes/:paiDK/:relMensalDk",
      templateUrl: "module/validacao/visualizacao/feitosMes/feitosMes.tab.html",
      controller: 'AbaFeitosMes',
      controllerAs: 'vm'
    });
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('AbaFeitosVistaAberta', AbaFeitosVistaAberta);

  function AbaFeitosVistaAberta(GlosaService, ParametroService, $state) {

    var vm = this;

    vm.init = init;

    vm.loadRegistros = loadRegistros;

    vm.isFeitosGlosados = isFeitosGlosados;
    vm.isFeitosPendentes = isFeitosPendentes;
    vm.camposPendentesDeclarados = camposPendentesDeclarados;
    vm.periodoSelecionado = $state.params.periodoSelecionado;

    vm.totalReconhecidosPeloMembroCalculado = 0;

    vm.init();

    function init() {
      vm.promotorSelecionado = $state.params.promotorSelecionado;
      vm.relDkSelecionado = $state.params.relDkSelecionado;
      vm.loadRegistros();

      ParametroService.getLimiteDiasFeitosVistaAberta(vm.periodoSelecionado).then(function (data) {
        vm.parametro = data;
      });
    }

    function loadRegistros() {

      vm.registrosList = {};

      GlosaService.getFeitosAbertosMais30Dias(vm.promotorSelecionado.originalObject.pessDk, vm.relDkSelecionado).then(function (data) {
        vm.registrosList = data;
        atualizaTotalReconhecido();
      });
    }

    function atualizaTotalReconhecido() {
      vm.totalReconhecidosPeloMembroCalculado = vm.registrosList.totalReconhecidosPeloMembro + (isNaN(vm.registrosList.quantidadeVistaAbertaDeclarada) ? 0 : vm.registrosList.quantidadeVistaAbertaDeclarada);
    }

    function isFeitosGlosados() {
      return vm.registrosList.totalFeitosOrigemMGP !== vm.registrosList.totalReconhecidosPeloMembro;
    }

    function isFeitosPendentes() {
      return vm.registrosList.totalReconhecidosPeloMembro !== 0;
    }

    function camposPendentesDeclarados() {
      var isQuantidadePresente = vm.registrosList.quantidadeVistaAbertaDeclarada !== null && vm.registrosList.quantidadeVistaAbertaDeclarada !== "" && vm.registrosList.quantidadeVistaAbertaDeclarada >= 0;

      var isJustificativaPresente = vm.registrosList.justificativaVistaAbertaDeclarada !== null && vm.registrosList.justificativaVistaAbertaDeclarada !== "";

      return isQuantidadePresente !== isJustificativaPresente;
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider.state('visualizacao.feitosVistaAberta', {
      url: "/feitosVistaAberta",
      templateUrl: "module/validacao/visualizacao/feitosVistaAberta/feitos-vista-aberta.tab.html",
      controller: 'AbaFeitosVistaAberta',
      controllerAs: 'vm'
    });
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('AbaPrincipalVisualizacao', AbaPrincipal);

  function AbaPrincipal(GlosaService, ParametroService, $state) {

    var vm = this;
    vm.init = init;
    vm.justificativaGlosaTotal = null;

    vm.init();

    function init() {

      vm.parametro = {};

      vm.promotorSelecionado = $state.params.promotorSelecionado;
      vm.relDkSelecionado = $state.params.relDkSelecionado;
      vm.periodoSelecionado = $state.params.periodoSelecionado;

      GlosaService.getLinhasPrincipal(vm.promotorSelecionado.originalObject.pessDk, vm.relDkSelecionado).then(function (data) {
        vm.linhas = data;
        vm.existeAbertoCom30Dias = vm.linhas[2] !== undefined && vm.linhas[2] !== null;
      });

      GlosaService.getRelatorioCorrente(vm.promotorSelecionado.originalObject.pessDk, vm.relDkSelecionado).then(function (data) {
        vm.currentRel = data;
        vm.parametro.ultimoDiaMes = vm.currentRel.lastDay;
      });

      GlosaService.getEnvioRegistro(vm.promotorSelecionado.originalObject.pessDk, vm.relDkSelecionado).then(function (data) {
        vm.registroMsmMca = data;
      });

      GlosaService.recuperaJustificativaGlosaTotalByRmenDK(vm.promotorSelecionado.originalObject.pessDk, vm.relDkSelecionado).then(function (data) {
        vm.justificativaGlosaTotal = data.justificativaGlosaTotal;
      });

      ParametroService.getLimiteDiasFeitosVistaAberta(vm.periodoSelecionado).then(function (data) {
        vm.parametro.quantidadeDias = data.quantidadeDias;
      });
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider.state('visualizacao.principal', {
      url: "/principal",
      templateUrl: "module/validacao/visualizacao/principal/principal.tab.html",
      controller: 'AbaPrincipalVisualizacao',
      controllerAs: 'vm'
    });
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('ModalDetalheAnaliticoDirectiveController', ModalDetalheAnaliticoDirectiveController);

  ModalDetalheAnaliticoDirectiveController.$inject = ['$uibModal', 'VisualizacaoService'];

  function ModalDetalheAnaliticoDirectiveController($uibModal, VisualizacaoService) {
    var vm = this;
    vm.openModal = openModal;

    function openModal() {
      VisualizacaoService.getDetalhamentoAnalitico(vm.pess, vm.rel, vm.id).then(function (data) {
        $uibModal.open({
          templateUrl: 'module/validacao/visualizacao/modalDetalheAnalitico/modal-detalhe-analitico.html',
          controller: 'ModalInstanceDetalheAnalitico',
          controllerAs: 'vm',
          windowClass: 'modal-detalhamento',
          resolve: {
            detalhamentoAnalitico: function detalhamentoAnalitico() {
              return data;
            }
          }
        });
      });
    }
  }
})();
'use strict';

// FIXME TESTAR!!!

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').directive('modalDetalheAnalitico', ModalDetalheAnalitico);

  function ModalDetalheAnalitico() {
    var directive = {

      restrict: 'E',
      template: '<a href="" ng-click="vm.openModal()" title="Detalhamento Analítico">{{vm.title}}</a>',
      scope: {
        title: '@',
        id: '@',
        pess: '@',
        rel: '@'
      },
      controller: 'ModalDetalheAnaliticoDirectiveController',
      controllerAs: 'vm',
      bindToController: true

    };
    return directive;
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('ModalInstanceDetalheAnalitico', ModalInstanceDetalheAnalitico);

  function ModalInstanceDetalheAnalitico($uibModalInstance, detalhamentoAnalitico) {

    var vm = this;
    vm.detalhamentoAnalitico = detalhamentoAnalitico;
    vm.close = close;

    function close() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('DataService', DataService);

  function DataService() {

    var service = {
      convertDate: convertDate,
      convertDateFullDate: convertDateFullDate
    };

    return service;

    function convertDate(date) {

      if (date === null || date === '') {
        return ''; // se data estiver vazia nao ha o que converter
      }

      return moment(date, 'YYYYMM').format('MMMM/YYYY');
    }

    function convertDateFullDate(number) {

      if (number === null || number === '') {
        return ''; // se data estiver vazia nao ha o que converter
      }

      return moment(number).format('DD/MM/YYYY');
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('FiltroRelatorio', FiltroRelatorio);

  function FiltroRelatorio($state, FiltroRelatorioService, $stateParams, ngsalConfig, i18n, PromotorService) {

    var vm = this;

    var FORMATO_MES = 'MM';
    var FORMATO_MES_EXTENSO = 'MMMM';
    var FORMATO_ANO = 'YYYY';
    var FORMATO_ANO_MES = 'YYYYMM';

    vm.init = init;
    vm.loadRelatorios = loadRelatorios;
    vm.visualizarRelatorio = visualizarRelatorio;
    vm.loadAnos = loadAnos;
    vm.loadMeses = loadMeses;
    vm.isSearchEnabled = isSearchEnabled;
    vm.carregaSituacoesPossiveis = carregaSituacoesPossiveis;
    vm.consultarPromotor = consultarPromotor;
    vm.versionApi = ngsalConfig.apiVersion;

    vm.init();

    function loadRelatorios() {

      vm.periodoSelecionado = vm.anoSelecionado + moment().month(vm.mesSelecionado).format(FORMATO_MES);

      FiltroRelatorioService.getRelatoriosByPromotorAndPeriodoAndSituacao(vm.promotorSelecionado.originalObject.pessDk, vm.periodoSelecionado, vm.situacao.value).then(loadRelatoriosOnSuccess);

      function loadRelatoriosOnSuccess(data) {
        vm.relatoriosByOrgaoList = data;

        if (vm.relatoriosByOrgaoList.length === 1) {
          vm.expandAccordion = true;
        }
      }
    }

    function consultarPromotor(query, timeoutPromise) {
      return PromotorService.consultarPromotor(query, timeoutPromise);
    }

    function visualizarRelatorio(relatorio, orgao) {
      FiltroRelatorioService.visualizarRelatorio(relatorio, orgao, vm.periodoSelecionado, vm.promotorSelecionado.originalObject.pessDk).then(function () {
        $state.go('visualizacao.principal', {
          periodoSelecionado: vm.periodoSelecionado,
          nomeOrgaoFiltrado: vm.nomeOrgaoFilter,
          promotorSelecionado: vm.promotorSelecionado,
          relDkSelecionado: relatorio.id,
          situacaoSelecionada: vm.situacao
        });
      });
    }

    function init() {

      vm.loadAnos();

      // Usado pelo Tour
      vm.expandAccordion = false;

      if ($state.params.referer === 'botaoVoltar') {
        vm.nomeOrgaoFilter = $state.params.nomeOrgaoFiltrado;
        vm.periodoSelecionado = $state.params.periodoSelecionado;
        vm.anoSelecionado = moment(vm.periodoSelecionado, FORMATO_ANO_MES).format(FORMATO_ANO);
        vm.mesSelecionado = moment(vm.periodoSelecionado, FORMATO_ANO_MES).format(FORMATO_MES_EXTENSO);

        vm.promotorSelecionado = $state.params.promotorSelecionado;
        vm.nomePromotorSelecionado = vm.promotorSelecionado.originalObject.nomePromotor;

        vm.loadMeses();

        vm.carregaSituacoesPossiveis().then(function () {
          vm.loadRelatorios();
        });
      } else {
        vm.carregaSituacoesPossiveis();
      }
    }

    function carregaSituacoesPossiveis() {
      var promise = FiltroRelatorioService.carregaSituacoesPossiveis().then(function (response) {
        vm.opcoesFiltroSituacao = response;

        if ($state.params.referer === 'botaoVoltar') {
          vm.situacao = $state.params.situacaoSelecionada;
        } else {
          vm.situacao = vm.opcoesFiltroSituacao[0];
        }
      });

      return promise;
    }

    function loadAnos() {

      vm.anos = [];

      var minYear = i18n.translate("application.startYear");
      var currentYear = moment().year();

      while (currentYear >= minYear) {
        vm.anos.push(currentYear--);
      }
    }

    function loadMeses() {
      vm.meses = [];

      var currentYear = moment().year();

      if (currentYear === parseInt(vm.anoSelecionado)) {
        moment.months().forEach(function (monthName) {
          var month = moment().month(monthName);

          if (moment(month).isSameOrBefore(moment(), 'month')) {
            vm.meses.push(monthName);
          }
        });
      } else {
        vm.meses = moment.months();
      }
    }

    function isSearchEnabled() {
      return vm.promotorSelecionado && vm.anoSelecionado && vm.mesSelecionado;
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider.state('validoEnviados', {
      url: "/membro/validacao/relatorio",
      templateUrl: 'module/validacao/filtro/enviados.html',
      controller: 'FiltroRelatorio',
      controllerAs: 'vm',
      params: {
        periodoSelecionado: '',
        nomeOrgaoFiltrado: '',
        referer: '',
        promotorSelecionado: '',
        situacaoSelecionada: ''
      }
    });
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('FiltroRelatorioService', FiltroRelatorioService);

  function FiltroRelatorioService($http, ngsalConfig) {

    var service = {
      getRelatoriosByPromotorAndPeriodoAndSituacao: getRelatoriosByPromotorAndPeriodoAndSituacao,
      visualizarRelatorio: visualizarRelatorio,
      carregaSituacoesPossiveis: carregaSituacoesPossiveis
    };

    return service;

    function getRelatoriosByPromotorAndPeriodoAndSituacao(pessDk, periodo, situacao) {

      var endpoint = '/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/promotor/' + pessDk + '/periodo/' + periodo;
      endpoint += '?situacao=' + situacao;

      var promise = $http.get(endpoint).then(function (response) {
        return response.data;
      });

      return promise;
    }

    function visualizarRelatorio(relatorio, orgao, periodo, pessDk) {

      var param = {
        orgaoDk: orgao.id,
        nomeOrgao: orgao.nome,
        anoMes: periodo,
        relDk: relatorio.id,
        nome: relatorio.nome,
        relMensalDK: relatorio.relMensalDK,
        glosaTotal: relatorio.glosaTotal
      };

      var promise = $http.put('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/promotor/' + pessDk + '/relatorio/' + relatorio.relMensalDK, param).then(function (response) {
        return response.data;
      });

      return promise;
    }

    function carregaSituacoesPossiveis() {

      var endpoint = '/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/relatorio/filtro/situacao';

      var promise = $http.get(endpoint).then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').constant('PARAMETRO', {
    LIMITE_FEITOS_VISTA_ABERTA: 73 //  Limite de dias para feitos com vista
    //  aberta (Relatórios da Corregedoria - Membros)
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('ParametroService', ParametroService);

  function ParametroService($http, ngsalConfig, PARAMETRO) {

    var service = {
      getLimiteDiasFeitosVistaAberta: getLimiteDiasFeitosVistaAberta
    };

    return service;

    function getLimiteDiasFeitosVistaAberta(anoMes) {

      var endpoint = '/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/parametro/';
      endpoint += PARAMETRO.LIMITE_FEITOS_VISTA_ABERTA + '?anoMes=' + anoMes;

      var promise = $http.get(endpoint).then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').constant('CONSTANTS', {
    QUANTIDADE_MAXIMA_MEMBRO_RELATORIO_CONCURSO: 15, //Quantidade maxima permitida de inclusao de membros no relatorio de concurso
    QUANTIDADE_MAXIMA_ORGAO_RELATORIO_ORGAO: 15, //Quantidade maxima permitida de inclusao de orgao no relatorio de orgao
    ANO_INICIO_ANUARIO: 2017 //Ano inicial do relatorio anuario
  });
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider.state('relatorioVistaAbertaCorregedoria', {
      url: "/membro/relatorioCorregedoria/relatorioVistaAberta",
      templateUrl: 'module/corregedoria/relatorioVistaAberta/relatorioVistaAberta.html',
      controller: 'RelatorioVistaAbertaCorregedoria',
      controllerAs: 'vm',
      params: {
        filtros: {},
        referer: ''
      }
    }).state('relatorioVistaAbertaPromotor', {
      url: "/membro/relatorioVistaAbertaPromotor/relatorioVistaAberta/:periodoInicial/:periodoFinal/:nomePromotor/:pessDk",
      templateUrl: 'module/corregedoria/relatorioVistaAbertaPromotor/relatorioVistaAbertaPromotor.html',
      controller: 'RelatorioVistaAbertaPromotor',
      controllerAs: 'vm',
      params: {
        periodoInicial: '',
        periodoFinal: '',
        nomePromotor: '',
        pessDk: '',
        filtros: {}
      }
    }).state('relatorioConcursoCorregedoria', {
      url: "/membro/relatorioCorregedoria/relatorioConcurso",
      templateUrl: 'module/corregedoria/relatorioConcurso/relatorioConcurso.html',
      controller: 'RelatorioConcursoCorregedoria',
      controllerAs: 'vm'
    });
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('PeriodoService', PeriodoService);

  function PeriodoService() {

    var service = {
      loadPeriodosFiltro: loadPeriodosFiltro,
      carregaAnosValidosAte: carregaAnosValidosAte
    };

    return service;

    function loadPeriodosFiltro() {
      var sort = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'asc';


      var dataLimiteFinal = new Date(moment().format('YYYY'), moment().format('MM') - 3, 1);

      var dataInicial = new Date(moment().format('YYYY'), moment().format('MM') - 13, 1);

      var periodoRelatorioEnviadoList = [];

      if (sort === 'asc') {
        while (dataInicial <= dataLimiteFinal) {
          periodoRelatorioEnviadoList.push(retornaDataFormatada(dataInicial));
          dataInicial = new Date(dataInicial.getFullYear(), dataInicial.getMonth() + 1, 1);
        }
      }
      if (sort === 'desc') {
        while (dataLimiteFinal >= dataInicial) {
          periodoRelatorioEnviadoList.push(retornaDataFormatada(dataLimiteFinal));
          dataLimiteFinal = new Date(dataLimiteFinal.getFullYear(), dataLimiteFinal.getMonth() - 1, 1);
        }
      }

      function retornaDataFormatada(data) {
        var mes = (data.getMonth() + 1).toString();
        return data.getFullYear().toString() + (mes.length === 1 ? '0' + mes : mes);
      }

      return periodoRelatorioEnviadoList;
    }

    function carregaAnosValidosAte(anoBase) {
      var anoList = [];

      if (typeof anoBase !== 'number' || anoBase < 0) {
        throw new Error("anoBase deve ser de tipo number e positivo");
      }

      var anoAtualValido = parseInt(moment().subtract(2, 'months').format("YYYY"));
      if (anoAtualValido < anoBase) {
        throw new Error("anoBase deve ser anterior que o ano atual");
      }

      for (var contador = anoAtualValido; anoBase <= contador; contador--) {
        console.log(contador);
        anoList.push(contador);
      }

      return anoList;
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('DashboardController', DashboardController);

  function DashboardController(DataService, DashboardService) {

    var vm = this;

    vm.init = init;
    vm.convertDate = convertDate;

    vm.init();

    function init() {
      DashboardService.loadEstatisticaRelatoriosEnviados().then(function (data) {
        vm.statusEnvioList = data;
      });
    }

    function convertDate(date) {
      return DataService.convertDate(date);
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider.state('dashboard', {
      url: "/dashboard",
      templateUrl: 'module/corregedoria/dashboard/dashboard.html',
      controller: 'DashboardController',
      controllerAs: 'vm'
    });
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('DashboardService', DashboardService);

  function DashboardService($http, ngsalConfig) {

    var service = {
      loadEstatisticaRelatoriosEnviados: loadEstatisticaRelatoriosEnviados
    };

    return service;

    function loadEstatisticaRelatoriosEnviados(membros) {

      var promise = $http.get('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/corregedoria/dashboard/relatorios/enviados').then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('OrgaoService', OrgaoService);

  function OrgaoService($http, ngsalConfig) {
    var service = {
      consultarOrgao: consultarOrgao
    };

    return service;

    function consultarOrgao(query, timeoutPromise) {

      var promise = $http.post('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/orgao', {
        query: query
      }, {
        timeoutPromise: timeoutPromise
      }).then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('PromotorService', PromotorService);

  function PromotorService($http, ngsalConfig) {
    var service = {
      consultarPromotor: consultarPromotor
    };

    return service;

    function consultarPromotor(query, timeoutPromise) {
      var somenteAtivos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


      var promise = $http.post('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/promotor', {
        somenteAtivos: somenteAtivos,
        query: query
      }, {
        timeoutPromise: timeoutPromise
      }).then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider.state('relatorioAvalOrgao', {
      url: "/relatorioAvaliacaoOrgao",
      templateUrl: 'module/corregedoria/relatorioAvalOrgao/relatorioAvalOrgao.html',
      controller: 'RelatorioAvalOrgao',
      controllerAs: 'vm'
    });
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('RelatorioAvalOrgao', RelatorioAvalOrgao);

  function RelatorioAvalOrgao(RelatorioAvalOrgaoService, OrgaoService, CONSTANTS, $scope, blockUI, i18n, FileSaver, toaster, Blob) {

    var vm = this;
    vm.init = init;
    vm.consultarOrgao = consultarOrgao;
    vm.adicionarOrgao = adicionarOrgao;
    vm.removerOrgao = removerOrgao;
    vm.subirPosicao = subirPosicao;
    vm.descerPosicao = descerPosicao;
    vm.exibeBotaoAdicionar = exibeBotaoAdicionar;
    vm.exportarExcel = exportarExcel;

    vm.init();

    function init() {
      vm.orgaosList = [];
      vm.permiteExportacao = false;
      vm.quantidadeMaxima = {
        quantidade: CONSTANTS.QUANTIDADE_MAXIMA_ORGAO_RELATORIO_ORGAO
      };
    }

    function consultarOrgao(query, timeoutPromise) {
      return OrgaoService.consultarOrgao(query, timeoutPromise);
    }

    function adicionarOrgao() {

      vm.permiteExportacao = true;

      if (vm.orgaosList.length < CONSTANTS.QUANTIDADE_MAXIMA_ORGAO_RELATORIO_ORGAO) {
        vm.orgaosList.push(vm.orgaoSelecionado.originalObject);
      }

      $scope.$broadcast('angucomplete-alt:clearInput');
    }

    function exibeBotaoAdicionar() {
      return vm.orgaosList.length < CONSTANTS.QUANTIDADE_MAXIMA_ORGAO_RELATORIO_ORGAO;
    }

    function removerOrgao(idx) {
      vm.orgaosList.splice(idx, 1);

      if (vm.orgaosList.length === 0) {
        vm.permiteExportacao = false;
      } else {
        vm.permiteExportacao = true;
      }
    }

    function subirPosicao(idx) {
      if (idx > 0) {
        var temp = vm.orgaosList[idx - 1];
        vm.orgaosList[idx - 1] = vm.orgaosList[idx];
        vm.orgaosList[idx] = temp;
      }
    }

    function descerPosicao(idx) {
      if (idx !== vm.orgaosList.length - 1) {
        var temp = vm.orgaosList[idx + 1];
        vm.orgaosList[idx + 1] = vm.orgaosList[idx];
        vm.orgaosList[idx] = temp;
      }
    }

    function exportarExcel() {
      blockUI.start();
      RelatorioAvalOrgaoService.exportarExcel(vm.orgaosList).then(function (response) {
        if (response.status === 204) {
          toaster.pop("warning", i18n.translate("relatorio.avaliacao.orgao.titulo"), i18n.translate("relatorio.sem.dados"));
        }
        if (response.status === 200) {
          var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          FileSaver.saveAs(blob, 'relatorio-avaliacao-orgao.xlsx');
        }
      }).finally(function () {
        blockUI.stop();
      });
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('RelatorioAvalOrgaoService', RelatorioAvalOrgaoService);

  function RelatorioAvalOrgaoService($http, ngsalConfig) {

    var service = {
      exportarExcel: exportarExcel
    };

    return service;

    function exportarExcel(orgaos) {
      var promise = $http.post('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/corregedoria/relatorioAvalOrgao', orgaos, {
        responseType: 'blob',
        headers: {
          Accept: 'application/vnd.ms-excel'
        }
      }).then(function (response) {
        return { data: response.data, status: response.status };
      });

      return promise;
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider.state('anuarioSimplificado', {
      url: "/anuarioSimplificado",
      templateUrl: 'module/corregedoria/relatorioAnual/simplificado/relatorio.html',
      controller: 'RelatorioAnualSimplificadoController',
      controllerAs: 'vm'
    }).state('anuarioCompleto', {
      url: "/anuarioCompleto",
      templateUrl: 'module/corregedoria/relatorioAnual/completo/relatorio.html',
      controller: 'RelatorioAnualCompletoController',
      controllerAs: 'vm'
    });
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('RelatorioAnualService', RelatorioAnualService);

  function RelatorioAnualService($http, ngsalConfig) {

    var service = {
      exportarSimplificado: exportarSimplificado,
      exportarCompleto: exportarCompleto,
      getRegistrosFilhosBy: getRegistrosFilhosBy
    };

    return service;

    function exportarSimplificado(periodo, tipoExportacao) {
      var promise = $http.post('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/anuario/simplificado/' + periodo, {}, {
        responseType: 'blob',
        headers: {
          'Accept': tipoExportacao
        }
      }).then(function (response) {
        return { data: response.data, status: response.status };
      });

      return promise;
    }

    function exportarCompleto(parametros) {
      var promise = $http.post('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/anuario/completo/' + parametros.periodo, parametros, {
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf'
        }
      }).then(function (response) {
        return { data: response.data, status: response.status };
      });

      return promise;
    }

    function getRegistrosFilhosBy(registroAtual) {

      registroAtual = registroAtual || {};
      var promise = $http.post('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/anuario/completo/registro/filhos', registroAtual).then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('RelatorioConcursoCorregedoria', RelatorioConcursoCorregedoria);

  function RelatorioConcursoCorregedoria(RelatorioConcursoService, FileSaver, Blob, ngsalConfig, $scope, toaster, i18n, blockUI, PromotorService, CONSTANTS) {

    var vm = this;

    vm.init = init;
    vm.adicionarPromotor = adicionarPromotor;
    vm.removerPromotor = removerPromotor;
    vm.exportarExcel = exportarExcel;
    vm.subirPosicao = subirPosicao;
    vm.descerPosicao = descerPosicao;
    vm.exibeBotaoAdicionar = exibeBotaoAdicionar;
    vm.consultarPromotor = consultarPromotor;

    vm.init();

    function init() {
      vm.versionApi = ngsalConfig.apiVersion;
      vm.promotoresList = [];
      vm.permiteExportacao = false;
      vm.quantidadeMaxima = {
        quantidade: CONSTANTS.QUANTIDADE_MAXIMA_MEMBRO_RELATORIO_CONCURSO
      };
    }

    function consultarPromotor(query, timeoutPromise) {
      return PromotorService.consultarPromotor(query, timeoutPromise, true);
    }

    function adicionarPromotor() {

      vm.permiteExportacao = true;

      if (vm.promotoresList.length < CONSTANTS.QUANTIDADE_MAXIMA_MEMBRO_RELATORIO_CONCURSO) {
        vm.promotoresList.push(vm.promotorSelecionado.originalObject);
      }

      $scope.$broadcast('angucomplete-alt:clearInput');
    }

    function exibeBotaoAdicionar() {
      return vm.promotoresList.length < CONSTANTS.QUANTIDADE_MAXIMA_MEMBRO_RELATORIO_CONCURSO;
    }

    function removerPromotor(idx) {
      vm.promotoresList.splice(idx, 1);

      if (vm.promotoresList.length === 0) {
        vm.permiteExportacao = false;
      } else {
        vm.permiteExportacao = true;
      }
    }

    function subirPosicao(idx) {
      if (idx > 0) {
        var temp = vm.promotoresList[idx - 1];
        vm.promotoresList[idx - 1] = vm.promotoresList[idx];
        vm.promotoresList[idx] = temp;
      }
    }

    function descerPosicao(idx) {
      if (idx !== vm.promotoresList.length - 1) {
        var temp = vm.promotoresList[idx + 1];
        vm.promotoresList[idx + 1] = vm.promotoresList[idx];
        vm.promotoresList[idx] = temp;
      }
    }

    function exportarExcel() {
      blockUI.start();
      RelatorioConcursoService.exportarExcel(vm.promotoresList).then(function (data) {
        if (data !== null && data.size === 0) {
          toaster.pop("warning", i18n.translate("corregedoria.relatorio.concurso.titulo"), i18n.translate("relatorio.sem.dados"));
        } else {
          var blob = new Blob([data], { type: 'application/vnd.ms-excel' });
          FileSaver.saveAs(blob, 'relatorio-concurso.xlsx');
        }
      }).finally(function () {
        blockUI.stop();
      });
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('RelatorioConcursoService', RelatorioConcursoService);

  function RelatorioConcursoService($http, ngsalConfig) {

    var service = {
      exportarExcel: exportarExcel
    };

    return service;

    function exportarExcel(membros) {
      var promise = $http.post("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/corregedoria/relatorioConcurso", membros, {
        responseType: 'blob',
        headers: {
          Accept: 'application/vnd.ms-excel'
        }
      }).then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider.state('agendamentoRelatorioEleitoral', {
      url: "/membro/relatorioEleitoral/agendamento",
      templateUrl: 'module/corregedoria/relatorioEleitoral/agendamento/agendamento.html',
      controller: 'AgendamentoRelatorioEleitoral',
      controllerAs: 'vm'
    });
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('FiltroRelatorio30DiasValidator', FiltroRelatorio30DiasValidator);

  function FiltroRelatorio30DiasValidator() {

    var validator = {
      getErrors: getErrors
    };

    return validator;

    /**
    * Mês inicial é obrigatório
    * Mês inicial não deve ser anterior a 12 meses em relação à data atual
    *
    * Mês final é obrigatório
    * Mês final não deve ser, no máximo, dois meses anterior em relação à data atual
    *
    * Mês inicial não pode ser posterior ao mês final
    * Mês inicial e final podem ser iguais
    *
    * Frequência não é obrigatório
    * Frequência não deve ser maior do que a quantidade de meses especificada no período
    *
    * Quantidade de dias é obrigatório
    * Quantidade de dias não pode ser menor do que 30
    *
    * Total de feitos reconhecidos não é obrigatório
    * Total de feitos impugnados não é obrigatório
    * Total de feitos sem justificativa não é obrigatório
    */
    function getErrors(filter) {

      var errors = [];

      var periodoInicial = moment(filter.periodoInicial, 'YYYYMM');
      var periodoFinal = moment(filter.periodoFinal, 'YYYYMM');
      var mesAtual = moment();
      var mesPassado = moment().subtract(1, 'months');
      var frequencia = filter.frequencia;

      if (frequencia !== null && (frequencia > 12 || frequencia < 0)) {
        errors.push('corregedoria.relatorio30dias.filtro.validacao.frequencia.fora.range');
      }
      if (isBlank(filter.periodoInicial)) {
        errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.inicial.obrigatorio');
      }
      if (isBlank(filter.periodoFinal)) {
        errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.final.obrigatorio');
      }

      if (periodoInicial.isValid() && periodoFinal.isValid() && periodoInicial.isAfter(periodoFinal)) {
        errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.inicial.invalido');
      }
      if (periodoInicial.isValid() && periodoInicial.isBefore(moment().startOf('month').subtract(1, 'years'))) {
        errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.inicial.invalido');
      }

      if (periodoFinal.isValid() && mesAtual.isSame(periodoFinal, 'month')) {
        errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.final.invalido.igual.atual');
      }
      if (periodoFinal.isValid() && mesPassado.isSame(periodoFinal, 'month')) {
        errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.final.invalido.igual.passado');
      }

      if (filter.tipo === 'Corregedoria') {
        if (isBlank(filter.diasEmAtraso)) {
          errors.push('corregedoria.relatorio30dias.filtro.validacao.quantidade.dias.invalido');
        }

        if (isNotBlank(filter.periodoInicial) && isNotBlank(filter.periodoFinal)) {
          if (filter.frequencia > periodoFinal.diff(periodoInicial, 'months') + 1) {
            errors.push('corregedoria.relatorio30dias.filtro.validacao.frequencia.invalida');
          }
        }
      }
      if (filter.tipo === 'Promotor') {
        if (isBlank(filter.nomePromotor) || isBlank(filter.pessDk)) {
          errors.push('corregedoria.relatorio30dias.filtro.validacao.promotor.obrigatorio');
        }
      }

      return errors;
    }

    /* private */
    function isBlank(value) {
      return value === null || value === undefined || value === '';
    }

    function isNotBlank(value) {
      return !isBlank(value);
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('RelatorioVistaAbertaService', RelatorioVistaAbertaService);

  function RelatorioVistaAbertaService($http, ngsalConfig) {

    var service = {
      retornaRelatorioVistaAbertaCorregedoria: retornaRelatorioVistaAbertaCorregedoria
    };

    return service;

    function retornaRelatorioVistaAbertaCorregedoria(filtroRelatorio) {

      var promise = $http.post("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/relatorio/vistaAberta/corregedoria", filtroRelatorio).then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('RelatorioVistaAbertaCorregedoria', RelatorioVistaAbertaCorregedoria);

  function RelatorioVistaAbertaCorregedoria($state, DataService, toaster, i18n, FiltroRelatorio30DiasValidator, PeriodoService, RelatorioVistaAbertaService, ParametroService) {

    var vm = this;

    vm.init = init;
    vm.convertDate = convertDate;
    vm.convertDate = convertDate;
    vm.filtrarRelatorioVistaAberta = filtrarRelatorioVistaAberta;
    vm.detalheRelatorioVistaAbertaPromotor = detalheRelatorioVistaAbertaPromotor;
    vm.options = {
      type: "pie",
      width: "24",
      height: "24",
      sliceColors: ['#016FB0', '#2C3E50', '#924AB0']
    };

    var FORMATO_ANO_MES = 'YYYYMM';

    vm.init();

    function convertDate(date) {
      return DataService.convertDate(date);
    }

    function init() {
      if ($state.params.referer === 'botaoVoltar') {
        vm.periodoInicial = $state.params.filtros.periodoInicial;
        vm.periodoFinal = $state.params.filtros.periodoFinal;
        vm.qtdDias = $state.params.filtros.diasEmAtraso;
        vm.frequencia = $state.params.filtros.frequencia;
        vm.reconhecido = $state.params.filtros.totalReconhecidos;
        vm.impugnado = $state.params.filtros.totalImpugnados;
        vm.semJustificativa = $state.params.filtros.totalSemJustificativa;

        filtrarRelatorioVistaAberta();
      }

      vm.periodoRelatorioEnviadoList = PeriodoService.loadPeriodosFiltro();

      ParametroService.getLimiteDiasFeitosVistaAberta(moment().format(FORMATO_ANO_MES)).then(function (data) {
        vm.qtdDias = vm.qtdDias || data.quantidadeDias;
        vm.parametro = {
          quantidadeDias: data.quantidadeDias
        };
      });
    }

    function detalheRelatorioVistaAbertaPromotor(nomePromotor, pessDk) {
      $state.go('relatorioVistaAbertaPromotor', {
        periodoInicial: vm.periodoInicial,
        periodoFinal: vm.periodoFinal,
        nomePromotor: nomePromotor,
        pessDk: pessDk,
        filtros: {
          periodoInicial: vm.periodoInicial,
          periodoFinal: vm.periodoFinal,
          diasEmAtraso: vm.qtdDias,
          frequencia: vm.frequencia,
          totalReconhecidos: vm.reconhecido,
          totalImpugnados: vm.impugnado,
          totalSemJustificativa: vm.semJustificativa
        }
      });
    }

    function filtrarRelatorioVistaAberta() {
      vm.filter = {
        periodoInicial: vm.periodoInicial,
        periodoFinal: vm.periodoFinal,
        diasEmAtraso: vm.qtdDias,
        frequencia: vm.frequencia,
        totalReconhecidos: vm.reconhecido,
        totalImpugnados: vm.impugnado,
        totalSemJustificativa: vm.semJustificativa,
        tipo: "Corregedoria"
      };

      var erros = FiltroRelatorio30DiasValidator.getErrors(vm.filter);

      erros.map(function (erro) {
        toaster.pop('error', i18n.translate(erro));
      });

      if (!erros.length) {
        RelatorioVistaAbertaService.retornaRelatorioVistaAbertaCorregedoria(vm.filter).then(function (data) {
          vm.feitosByPromotoresList = data;

          if (vm.feitosByPromotoresList === null || vm.feitosByPromotoresList.length === 0) {
            toaster.pop('error', i18n.translate('relatorio.vista.aberta'), i18n.translate('label.nao.existem.registros'));
          }
        });
      }
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('RelatorioVistaAbertaPromotor', RelatorioVistaAbertaPromotor);

  function RelatorioVistaAbertaPromotor(DataService, toaster, i18n, FiltroRelatorio30DiasValidator, PeriodoService, $state, RelatorioVistaAbertaPromotorService, ngsalConfig, PromotorService) {

    var vm = this;

    vm.init = init;
    vm.convertDate = convertDate;
    vm.filtrarRelatorioVistaAberta = filtrarRelatorioVistaAberta;
    vm.calcularTotaisEPreparaGrafico = calcularTotaisEPreparaGrafico;
    vm.voltarRelatorioVistaAbertaCorregedoria = voltarRelatorioVistaAbertaCorregedoria;
    vm.consultarPromotor = consultarPromotor;

    vm.versionApi = ngsalConfig.apiVersion;

    vm.nomePromotor = '';
    vm.promotorSelecionado = {
      originalObject: {}
    };
    vm.colors = ['#016FB0', '#2C3E50', '#924AB0'];

    vm.init();

    function convertDate(date) {
      return DataService.convertDate(date);
    }

    function init() {
      vm.periodoRelatorioEnviadoList = PeriodoService.loadPeriodosFiltro();

      if ($state.params.periodoInicial !== '' && $state.params.periodoFinal !== '') {
        vm.periodoInicial = $state.params.periodoInicial;
        vm.periodoFinal = $state.params.periodoFinal;
        vm.nomePromotor = $state.params.nomePromotor;
        vm.pessDk = $state.params.pessDk;
        vm.exibeBotaoVoltar = true;
        filtrarRelatorioVistaAberta();
      }
    }

    function consultarPromotor(query, timeoutPromise) {
      return PromotorService.consultarPromotor(query, timeoutPromise);
    }

    function filtrarRelatorioVistaAberta() {

      if (vm.nomePromotor !== '') {
        vm.nomePromotorSelecionado = vm.nomePromotor;
      }

      if (vm.promotorSelecionado && vm.promotorSelecionado.originalObject && vm.promotorSelecionado.originalObject.nomePromotor) {
        vm.nomePromotor = vm.promotorSelecionado.originalObject.nomePromotor;
        vm.nomePromotorSelecionado = vm.promotorSelecionado.originalObject.nomePromotor;
        vm.pessDk = vm.promotorSelecionado.originalObject.pessDk;
      }

      vm.filter = {
        periodoInicial: vm.periodoInicial,
        periodoFinal: vm.periodoFinal,
        nomePromotor: vm.nomePromotor,
        pessDk: vm.pessDk,
        tipo: "Promotor",
        frequencia: null
      };

      var erros = FiltroRelatorio30DiasValidator.getErrors(vm.filter);
      erros.map(function (erro) {
        toaster.pop('error', i18n.translate(erro));
      });

      if (!erros.length) {

        RelatorioVistaAbertaPromotorService.retornaRelatorioVistaAbertaPromotor(vm.filter).then(function (data) {
          vm.feitosByPromotoresList = data;

          if (vm.feitosByPromotoresList === null || vm.feitosByPromotoresList.length === 0) {
            toaster.pop('error', i18n.translate('relatorio.vista.aberta'), i18n.translate('label.nao.existem.registros'));
          } else {
            calcularTotaisEPreparaGrafico();
          }
        });
      }
    }

    function voltarRelatorioVistaAbertaCorregedoria() {
      $state.go('relatorioVistaAbertaCorregedoria', {
        referer: 'botaoVoltar',
        filtros: $state.params.filtros
      });
    }

    function calcularTotaisEPreparaGrafico() {
      var x = 0;

      vm.totalReconhecido = 0;
      vm.totalImpugnado = 0;
      vm.totalSemJustificativa = 0;
      vm.meses = [];
      vm.listaReconhecido = [];
      vm.listaImpugnado = [];
      vm.listaSemJustificativa = [];

      for (; vm.feitosByPromotoresList.length > x; x++) {
        vm.totalReconhecido += vm.feitosByPromotoresList[x].totalReconhecidos;
        vm.totalImpugnado += vm.feitosByPromotoresList[x].totalImpugnados;
        vm.totalSemJustificativa += vm.feitosByPromotoresList[x].totalSemJustificativa;

        vm.meses[x] = convertDate(vm.feitosByPromotoresList[x].mes);

        vm.listaReconhecido[x] = vm.feitosByPromotoresList[x].totalReconhecidos;
        vm.listaImpugnado[x] = vm.feitosByPromotoresList[x].totalImpugnados;
        vm.listaSemJustificativa[x] = vm.feitosByPromotoresList[x].totalSemJustificativa;
      }

      vm.listaTotais = [vm.totalReconhecido, vm.totalImpugnado, vm.totalSemJustificativa];
      vm.titulosTotais = ["Reconhecido", "Impugnado", "SemJustificativa"];

      vm.quantidadePorMes = [vm.listaReconhecido, vm.listaImpugnado, vm.listaSemJustificativa];
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('RelatorioVistaAbertaPromotorService', RelatorioVistaAbertaPromotorService);

  function RelatorioVistaAbertaPromotorService($http, ngsalConfig) {

    var service = {
      retornaRelatorioVistaAbertaPromotor: retornaRelatorioVistaAbertaPromotor
    };

    return service;

    function retornaRelatorioVistaAbertaPromotor(filtroRelatorio) {

      var promise = $http.post("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/relatorio/vistaAberta/promotor", filtroRelatorio).then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').directive('nodeListVisualizacaoAnuario', NodeListVisualizacaoAnuario);

  function NodeListVisualizacaoAnuario($compile, $templateCache) {

    var directive = {

      restrict: 'E',
      terminal: true,
      scope: {
        nodes: '=ngModel',
        add: '&',
        exportar: '&'
      },
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element) {
      if (angular.isArray(scope.nodes)) {
        element.append($templateCache.get('sub-registros-visualizacao-anuario.html'));
      }
      $compile(element.contents())(scope.$new());
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('RelatorioAnualCompletoController', RelatorioAnualCompletoController);

  function RelatorioAnualCompletoController(blockUI, FileSaver, RelatorioAnualService, PeriodoService, i18n, toaster, CONSTANTS) {

    var vm = this;

    vm.init = init;
    vm.add = add;
    vm.populate = populate;
    vm.exportar = exportar;

    vm.init();

    function init() {
      vm.periodos = PeriodoService.carregaAnosValidosAte(CONSTANTS.ANO_INICIO_ANUARIO);
      vm.periodoSelecionado = vm.periodos[0];
      vm.registrosList = [];
      vm.populate(vm.registrosList);
    }

    function exportar(registroSelecionado) {
      blockUI.start();
      RelatorioAnualService.exportarCompleto({ periodo: vm.periodoSelecionado, registro: registroSelecionado }).then(function (response) {
        if (response.status === 204) {
          toaster.pop("warning", i18n.translate("menu.relatorio.corregedoria.anual") + '\n          ' + i18n.translate("menu.relatorio.corregedoria.anual.completo"), i18n.translate("relatorio.sem.dados"));
        }

        if (response.status === 200) {
          var blob = new Blob([response.data], { type: 'application/pdf' });
          FileSaver.saveAs(blob, 'anuario-completo.pdf');
        }
      }).finally(function () {
        blockUI.stop();
      });
    }

    function add(registro) {
      vm.data = registro;
      vm.populate(registro.subregistros);
    }

    function populate(lista) {
      if (lista.length === 0) {
        RelatorioAnualService.getRegistrosFilhosBy(vm.data).then(function (data) {
          data = data || [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var resultado = _step.value;

              resultado.subregistros = [];
              lista.push(resultado);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        });
      }
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('RelatorioAnualSimplificadoController', RelatorioAnualSimplificadoController);

  function RelatorioAnualSimplificadoController(blockUI, FileSaver, RelatorioAnualService, PeriodoService, i18n, toaster, CONSTANTS) {

    var vm = this;

    vm.init = init;
    vm.exportar = exportar;
    vm.init();

    function init() {
      vm.periodos = PeriodoService.carregaAnosValidosAte(CONSTANTS.ANO_INICIO_ANUARIO);
      vm.periodoSelecionado = vm.periodos[0];
    }

    function exportar() {
      blockUI.start();
      RelatorioAnualService.exportarSimplificado(vm.periodoSelecionado, 'application/pdf').then(function (response) {
        if (response.status === 204) {
          toaster.pop("warning", i18n.translate("menu.relatorio.corregedoria.anual") + '\n          ' + i18n.translate("menu.relatorio.corregedoria.anual.simplificado"), i18n.translate("relatorio.sem.dados"));
        }
        if (response.status === 200) {
          var blob = new Blob([response.data], { type: 'application/pdf' });
          FileSaver.saveAs(blob, 'anuario-simplificado.pdf');
        }
      }).finally(function () {
        blockUI.stop();
      });
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('AgendamentoRelatorioEleitoral', AgendamentoRelatorioEleitoral);

  function AgendamentoRelatorioEleitoral(PeriodoService, AgendamentoService, $uibModal, DataService) {

    var vm = this;

    vm.init = init;
    vm.confirmarAgendamento = confirmarAgendamento;
    vm.convertDate = convertDate;
    vm.convertDateFullDate = convertDateFullDate;
    vm.confirmarExclusao = confirmarExclusao;
    vm.agendamentosRealizados = [];

    vm.init();

    function init() {
      vm.periodos = PeriodoService.loadPeriodosFiltro('desc');
      vm.periodoSelecionado = vm.periodos[0];
      AgendamentoService.listarAgendamentosCorrente().then(function (result) {
        vm.agendamentosRealizados = result;
      });
      vm.today = moment();
    }

    function convertDate(date) {
      return DataService.convertDate(date);
    }

    function convertDateFullDate(number) {
      return DataService.convertDateFullDate(number);
    }

    function confirmarAgendamento() {
      return $uibModal.open({
        templateUrl: "module/corregedoria/relatorioEleitoral/agendamento/agendamento.confirmacao.html",
        controller: 'ModalInstanceConfirmacaoAgendamento',
        controllerAs: 'vm',
        resolve: {
          periodoSelecionado: function periodoSelecionado() {
            return { periodo: vm.periodoSelecionado, periodoExtenso: convertDate(vm.periodoSelecionado) };
          }
        }
      }).result.then(function () {
        AgendamentoService.listarAgendamentosCorrente().then(function (result) {
          vm.agendamentosRealizados = result;
        });
      });
    }

    function confirmarExclusao(idAgendamento) {
      return $uibModal.open({
        templateUrl: "module/corregedoria/relatorioEleitoral/agendamento/agendamento.exclusao.confirmacao.html",
        controller: 'ModalInstanceExclusaoAgendamento',
        controllerAs: 'vm',
        resolve: {
          parametros: function parametros() {
            return { periodo: vm.periodoSelecionado, periodoExtenso: convertDate(vm.periodoSelecionado), idAgendamento: idAgendamento };
          }
        }
      }).result.then(function () {
        AgendamentoService.listarAgendamentosCorrente().then(function (result) {
          vm.agendamentosRealizados = result;
        });
      });
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('AgendamentoService', AgendamentoService);

  function AgendamentoService($http, ngsalConfig) {

    var service = {
      realizarAgendamento: realizarAgendamento,
      listarAgendamentosCorrente: listarAgendamentosCorrente,
      excluirAgendamento: excluirAgendamento
    };

    return service;

    function realizarAgendamento(periodoSelecionado) {

      var promise = $http.post('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/relatorio/eleitoral/agendamento/' + periodoSelecionado).then(function (response) {
        return response.data;
      });

      return promise;
    }

    function listarAgendamentosCorrente() {
      var promise = $http.get('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/relatorio/eleitoral/agendamento').then(function (response) {
        return response.data;
      });

      return promise;
    }

    function excluirAgendamento(idAgendamento) {

      var promise = $http.delete('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/relatorio/eleitoral/agendamento/' + idAgendamento).then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('ModalInstanceConfirmacaoAgendamento', ModalInstanceConfirmacaoAgendamento);

  function ModalInstanceConfirmacaoAgendamento($uibModalInstance, periodoSelecionado, AgendamentoService, toaster, i18n) {

    var vm = this;
    vm.periodoSelecionado = periodoSelecionado;
    vm.cancelar = cancelar;
    vm.realizarAgendamento = realizarAgendamento;

    function cancelar() {
      $uibModalInstance.dismiss('cancel');
    }

    function realizarAgendamento() {
      AgendamentoService.realizarAgendamento(vm.periodoSelecionado.periodo).then(function () {
        $uibModalInstance.close();
        toaster.pop("success", i18n.translate("menu.agendamento.relatorio.eleitoral"), i18n.translate("relatorio.eleitoral.sucesso"));
      }).catch(function () {
        $uibModalInstance.dismiss();
      });
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('ModalInstanceExclusaoAgendamento', ModalInstanceExclusaoAgendamento);

  function ModalInstanceExclusaoAgendamento($uibModalInstance, parametros, AgendamentoService, toaster, i18n) {

    var vm = this;
    vm.parametros = parametros;
    vm.cancelar = cancelar;
    vm.excluirAgendamento = excluirAgendamento;

    function cancelar() {
      $uibModalInstance.dismiss('cancel');
    }

    function excluirAgendamento() {
      AgendamentoService.excluirAgendamento(vm.parametros.idAgendamento).then(function () {
        $uibModalInstance.close();
        toaster.pop("success", i18n.translate("menu.agendamento.relatorio.eleitoral"), i18n.translate("relatorio.eleitoral.exclusao.sucesso"));
      }).catch(function () {
        $uibModalInstance.dismiss();
      });
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('PendenciasRelatorioEleitoralController', PendenciasRelatorioEleitoralController);

  function PendenciasRelatorioEleitoralController(PendenciasRelatorioEleitoralService, PeriodoService, DataService) {

    var vm = this;

    vm.init = init;
    vm.convertDate = convertDate;
    vm.listarPendencias = listarPendencias;

    vm.init();

    function init() {
      vm.periodos = PeriodoService.loadPeriodosFiltro('desc');
      vm.periodoSelecionado = vm.periodos[0];
    }

    function convertDate(date) {
      return DataService.convertDate(date);
    }

    function listarPendencias() {
      vm.ultimoPeriodoExecutado = vm.periodoSelecionado;
      PendenciasRelatorioEleitoralService.listarPendencias(vm.periodoSelecionado).then(function (data) {
        vm.pendencias = data;
      });
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider.state('pendenciasRelatorioEleitoral', {
      url: "/membro/relatorioEleitoral/pendencias",
      templateUrl: 'module/corregedoria/relatorioEleitoral/pendencias/pendencias.html',
      controller: 'PendenciasRelatorioEleitoralController',
      controllerAs: 'vm'
    });
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('PendenciasRelatorioEleitoralService', PendenciasRelatorioEleitoralService);

  function PendenciasRelatorioEleitoralService($http, ngsalConfig) {

    var service = {
      listarPendencias: listarPendencias
    };

    return service;

    function listarPendencias(periodo) {

      var promise = $http.get('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/relatorio/eleitoral/pendencias/' + periodo).then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();
'use strict';

(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.info').controller('InfoController', InfoController);

  function InfoController(InfoService) {
    var vm = this;

    vm.init = init;
    vm.getInfo = getInfo;

    vm.init();

    function init() {
      vm.getInfo();
    }

    function getInfo() {
      InfoService.getInfo().then(function (data) {
        vm.apiVersion = 'v' + data.version + '-' + data.date;
      });
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.info').factory('InfoService', InfoService);

  function InfoService($http, ngsalConfig) {

    var service = {
      getInfo: getInfo
    };

    return service;

    function getInfo() {

      var promise = $http.get('/mgp-corregedoria/api/' + ngsalConfig.apiVersion + '/info').then(function (response) {
        return response.data;
      });

      return promise;
    }
  }
})();